/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as TestingRouteRouteImport } from './routes/testing/route'
import { Route as StartRouteRouteImport } from './routes/start/route'
import { Route as PortalRouteRouteImport } from './routes/portal/route'
import { Route as OnboardingRouteRouteImport } from './routes/onboarding/route'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TestingIndexRouteImport } from './routes/testing/index'
import { Route as PortalIndexRouteImport } from './routes/portal/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as TestingUsersRouteImport } from './routes/testing/users'
import { Route as TestingSystemToolsRouteImport } from './routes/testing/system-tools'
import { Route as ApplicationApplicationIdRouteImport } from './routes/application/$applicationId'
import { Route as ApplicationStatusApplicationIdRouteImport } from './routes/application-status/$applicationId'
import { Route as AdminOverviewRouteImport } from './routes/admin/overview'
import { Route as ProviderProviderIdRouteRouteImport } from './routes/provider.$providerId/route'
import { Route as PortalStartRouteRouteImport } from './routes/portal/start/route'
import { Route as PortalDepositAccountRouteRouteImport } from './routes/portal/deposit-account/route'
import { Route as AdminProvidersRouteRouteImport } from './routes/admin/providers/route'
import { Route as AdminImportTransactionsRouteRouteImport } from './routes/admin/import-transactions/route'
import { Route as AdminCustomersRouteRouteImport } from './routes/admin/customers/route'
import { Route as AdminConfigurationRouteRouteImport } from './routes/admin/configuration/route'
import { Route as AdminApplicationsRouteRouteImport } from './routes/admin/applications/route'
import { Route as AdminAccountsRouteRouteImport } from './routes/admin/accounts/route'
import { Route as ProviderProviderIdIndexRouteImport } from './routes/provider.$providerId/index'
import { Route as PortalDocumentsIndexRouteImport } from './routes/portal/documents/index'
import { Route as PortalDepositAccountIndexRouteImport } from './routes/portal/deposit-account/index'
import { Route as AdminProvidersIndexRouteImport } from './routes/admin/providers/index'
import { Route as AdminImportTransactionsIndexRouteImport } from './routes/admin/import-transactions/index'
import { Route as AdminCustomersIndexRouteImport } from './routes/admin/customers/index'
import { Route as AdminApplicationsIndexRouteImport } from './routes/admin/applications/index'
import { Route as AdminAccountsIndexRouteImport } from './routes/admin/accounts/index'
import { Route as ProviderProviderIdStartRouteImport } from './routes/provider.$providerId/start'
import { Route as AdminProvidersAddRouteImport } from './routes/admin/providers/add'
import { Route as AdminCustomersUserIdRouteImport } from './routes/admin/customers/$userId'
import { Route as AdminConfigurationSettingsRouteImport } from './routes/admin/configuration/settings'
import { Route as AdminApplicationsApplicationIdRouteImport } from './routes/admin/applications/$applicationId'
import { Route as ProviderProviderIdToolsRouteRouteImport } from './routes/provider.$providerId/tools/route'
import { Route as ProviderProviderIdTeamRouteRouteImport } from './routes/provider.$providerId/team/route'
import { Route as ProviderProviderIdApplicationsRouteRouteImport } from './routes/provider.$providerId/applications/route'
import { Route as PortalStartNewRouteRouteImport } from './routes/portal/start/new/route'
import { Route as PortalStartGuideRouteRouteImport } from './routes/portal/start/_guide/route'
import { Route as PortalDepositAccountDepositAccountIdRouteRouteImport } from './routes/portal/deposit-account/$depositAccountId/route'
import { Route as AdminProvidersProviderIdRouteRouteImport } from './routes/admin/providers/$providerId/route'
import { Route as AdminConfigurationTeamRouteRouteImport } from './routes/admin/configuration/team/route'
import { Route as AdminConfigurationProxyRouteRouteImport } from './routes/admin/configuration/proxy/route'
import { Route as AdminConfigurationOmnibusRouteRouteImport } from './routes/admin/configuration/omnibus/route'
import { Route as AdminConfigurationFundingAccountsRouteRouteImport } from './routes/admin/configuration/funding-accounts/route'
import { Route as AdminConfigurationApiKeysRouteRouteImport } from './routes/admin/configuration/api-keys/route'
import { Route as ProviderProviderIdToolsIndexRouteImport } from './routes/provider.$providerId/tools/index'
import { Route as ProviderProviderIdTeamIndexRouteImport } from './routes/provider.$providerId/team/index'
import { Route as ProviderProviderIdApplicationsIndexRouteImport } from './routes/provider.$providerId/applications/index'
import { Route as PortalStartNewIndexRouteImport } from './routes/portal/start/new/index'
import { Route as PortalStartGuideIndexRouteImport } from './routes/portal/start/_guide/index'
import { Route as PortalDepositAccountDepositAccountIdIndexRouteImport } from './routes/portal/deposit-account/$depositAccountId/index'
import { Route as AdminProvidersProviderIdIndexRouteImport } from './routes/admin/providers/$providerId/index'
import { Route as AdminConfigurationTeamIndexRouteImport } from './routes/admin/configuration/team/index'
import { Route as AdminConfigurationProxyIndexRouteImport } from './routes/admin/configuration/proxy/index'
import { Route as AdminConfigurationOmnibusIndexRouteImport } from './routes/admin/configuration/omnibus/index'
import { Route as AdminConfigurationFundingAccountsIndexRouteImport } from './routes/admin/configuration/funding-accounts/index'
import { Route as AdminConfigurationFeaturesIndexRouteImport } from './routes/admin/configuration/features/index'
import { Route as ProviderProviderIdTeamUserIdRouteImport } from './routes/provider.$providerId/team/$userId'
import { Route as ProviderProviderIdApplicationsApplicationIdRouteImport } from './routes/provider.$providerId/applications/$applicationId'
import { Route as PortalStartNewDepositAccountTypeRouteImport } from './routes/portal/start/new/$depositAccountType'
import { Route as PortalStartGuideRetirementCheckingRouteImport } from './routes/portal/start/_guide/retirement-checking'
import { Route as AdminConfigurationTeamUserIdRouteImport } from './routes/admin/configuration/team/$userId'
import { Route as AdminConfigurationProxyProxyIdRouteImport } from './routes/admin/configuration/proxy/$proxyId'
import { Route as AdminConfigurationOmnibusOmnibusAccountIdRouteImport } from './routes/admin/configuration/omnibus/$omnibusAccountId'
import { Route as PortalDepositAccountDepositAccountIdNewTransferRouteRouteImport } from './routes/portal/deposit-account/$depositAccountId/new-transfer/route'
import { Route as PortalDepositAccountDepositAccountIdHomeRouteRouteImport } from './routes/portal/deposit-account/$depositAccountId/home/route'
import { Route as PortalDepositAccountDepositAccountIdHomeIndexRouteImport } from './routes/portal/deposit-account/$depositAccountId/home/index'
import { Route as ProviderProviderIdApplicationsStatusApplicationIdRouteImport } from './routes/provider.$providerId/applications/status.$applicationId'
import { Route as PortalDepositAccountDepositAccountIdNewTransferAchRouteImport } from './routes/portal/deposit-account/$depositAccountId/new-transfer/ach'
import { Route as PortalDepositAccountDepositAccountIdHomeTransactionsRouteImport } from './routes/portal/deposit-account/$depositAccountId/home/transactions'
import { Route as PortalDepositAccountDepositAccountIdHomeAchRouteImport } from './routes/portal/deposit-account/$depositAccountId/home/ach'
import { Route as AdminProvidersProviderIdUsersUserIdRouteRouteImport } from './routes/admin/providers/$providerId/users.$userId.route'

const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const TestingRouteRoute = TestingRouteRouteImport.update({
  id: '/testing',
  path: '/testing',
  getParentRoute: () => rootRouteImport,
} as any)
const StartRouteRoute = StartRouteRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRouteRoute = PortalRouteRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRouteRoute = OnboardingRouteRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TestingIndexRoute = TestingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TestingRouteRoute,
} as any)
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalRouteRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const TestingUsersRoute = TestingUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => TestingRouteRoute,
} as any)
const TestingSystemToolsRoute = TestingSystemToolsRouteImport.update({
  id: '/system-tools',
  path: '/system-tools',
  getParentRoute: () => TestingRouteRoute,
} as any)
const ApplicationApplicationIdRoute =
  ApplicationApplicationIdRouteImport.update({
    id: '/application/$applicationId',
    path: '/application/$applicationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ApplicationStatusApplicationIdRoute =
  ApplicationStatusApplicationIdRouteImport.update({
    id: '/application-status/$applicationId',
    path: '/application-status/$applicationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminOverviewRoute = AdminOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AdminRouteRoute,
} as any)
const ProviderProviderIdRouteRoute = ProviderProviderIdRouteRouteImport.update({
  id: '/provider/$providerId',
  path: '/provider/$providerId',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalStartRouteRoute = PortalStartRouteRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalDepositAccountRouteRoute =
  PortalDepositAccountRouteRouteImport.update({
    id: '/deposit-account',
    path: '/deposit-account',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const AdminProvidersRouteRoute = AdminProvidersRouteRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminImportTransactionsRouteRoute =
  AdminImportTransactionsRouteRouteImport.update({
    id: '/import-transactions',
    path: '/import-transactions',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminCustomersRouteRoute = AdminCustomersRouteRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminConfigurationRouteRoute = AdminConfigurationRouteRouteImport.update({
  id: '/configuration',
  path: '/configuration',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminApplicationsRouteRoute = AdminApplicationsRouteRouteImport.update({
  id: '/applications',
  path: '/applications',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAccountsRouteRoute = AdminAccountsRouteRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AdminRouteRoute,
} as any)
const ProviderProviderIdIndexRoute = ProviderProviderIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProviderProviderIdRouteRoute,
} as any)
const PortalDocumentsIndexRoute = PortalDocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalDepositAccountIndexRoute =
  PortalDepositAccountIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PortalDepositAccountRouteRoute,
  } as any)
const AdminProvidersIndexRoute = AdminProvidersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminProvidersRouteRoute,
} as any)
const AdminImportTransactionsIndexRoute =
  AdminImportTransactionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminImportTransactionsRouteRoute,
  } as any)
const AdminCustomersIndexRoute = AdminCustomersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminCustomersRouteRoute,
} as any)
const AdminApplicationsIndexRoute = AdminApplicationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminApplicationsRouteRoute,
} as any)
const AdminAccountsIndexRoute = AdminAccountsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminAccountsRouteRoute,
} as any)
const ProviderProviderIdStartRoute = ProviderProviderIdStartRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => ProviderProviderIdRouteRoute,
} as any)
const AdminProvidersAddRoute = AdminProvidersAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => AdminProvidersRouteRoute,
} as any)
const AdminCustomersUserIdRoute = AdminCustomersUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => AdminCustomersRouteRoute,
} as any)
const AdminConfigurationSettingsRoute =
  AdminConfigurationSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AdminConfigurationRouteRoute,
  } as any)
const AdminApplicationsApplicationIdRoute =
  AdminApplicationsApplicationIdRouteImport.update({
    id: '/$applicationId',
    path: '/$applicationId',
    getParentRoute: () => AdminApplicationsRouteRoute,
  } as any)
const ProviderProviderIdToolsRouteRoute =
  ProviderProviderIdToolsRouteRouteImport.update({
    id: '/tools',
    path: '/tools',
    getParentRoute: () => ProviderProviderIdRouteRoute,
  } as any)
const ProviderProviderIdTeamRouteRoute =
  ProviderProviderIdTeamRouteRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => ProviderProviderIdRouteRoute,
  } as any)
const ProviderProviderIdApplicationsRouteRoute =
  ProviderProviderIdApplicationsRouteRouteImport.update({
    id: '/applications',
    path: '/applications',
    getParentRoute: () => ProviderProviderIdRouteRoute,
  } as any)
const PortalStartNewRouteRoute = PortalStartNewRouteRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => PortalStartRouteRoute,
} as any)
const PortalStartGuideRouteRoute = PortalStartGuideRouteRouteImport.update({
  id: '/_guide',
  getParentRoute: () => PortalStartRouteRoute,
} as any)
const PortalDepositAccountDepositAccountIdRouteRoute =
  PortalDepositAccountDepositAccountIdRouteRouteImport.update({
    id: '/$depositAccountId',
    path: '/$depositAccountId',
    getParentRoute: () => PortalDepositAccountRouteRoute,
  } as any)
const AdminProvidersProviderIdRouteRoute =
  AdminProvidersProviderIdRouteRouteImport.update({
    id: '/$providerId',
    path: '/$providerId',
    getParentRoute: () => AdminProvidersRouteRoute,
  } as any)
const AdminConfigurationTeamRouteRoute =
  AdminConfigurationTeamRouteRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => AdminConfigurationRouteRoute,
  } as any)
const AdminConfigurationProxyRouteRoute =
  AdminConfigurationProxyRouteRouteImport.update({
    id: '/proxy',
    path: '/proxy',
    getParentRoute: () => AdminConfigurationRouteRoute,
  } as any)
const AdminConfigurationOmnibusRouteRoute =
  AdminConfigurationOmnibusRouteRouteImport.update({
    id: '/omnibus',
    path: '/omnibus',
    getParentRoute: () => AdminConfigurationRouteRoute,
  } as any)
const AdminConfigurationFundingAccountsRouteRoute =
  AdminConfigurationFundingAccountsRouteRouteImport.update({
    id: '/funding-accounts',
    path: '/funding-accounts',
    getParentRoute: () => AdminConfigurationRouteRoute,
  } as any)
const AdminConfigurationApiKeysRouteRoute =
  AdminConfigurationApiKeysRouteRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => AdminConfigurationRouteRoute,
  } as any)
const ProviderProviderIdToolsIndexRoute =
  ProviderProviderIdToolsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProviderProviderIdToolsRouteRoute,
  } as any)
const ProviderProviderIdTeamIndexRoute =
  ProviderProviderIdTeamIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProviderProviderIdTeamRouteRoute,
  } as any)
const ProviderProviderIdApplicationsIndexRoute =
  ProviderProviderIdApplicationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProviderProviderIdApplicationsRouteRoute,
  } as any)
const PortalStartNewIndexRoute = PortalStartNewIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalStartNewRouteRoute,
} as any)
const PortalStartGuideIndexRoute = PortalStartGuideIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalStartGuideRouteRoute,
} as any)
const PortalDepositAccountDepositAccountIdIndexRoute =
  PortalDepositAccountDepositAccountIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PortalDepositAccountDepositAccountIdRouteRoute,
  } as any)
const AdminProvidersProviderIdIndexRoute =
  AdminProvidersProviderIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminProvidersProviderIdRouteRoute,
  } as any)
const AdminConfigurationTeamIndexRoute =
  AdminConfigurationTeamIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminConfigurationTeamRouteRoute,
  } as any)
const AdminConfigurationProxyIndexRoute =
  AdminConfigurationProxyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminConfigurationProxyRouteRoute,
  } as any)
const AdminConfigurationOmnibusIndexRoute =
  AdminConfigurationOmnibusIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminConfigurationOmnibusRouteRoute,
  } as any)
const AdminConfigurationFundingAccountsIndexRoute =
  AdminConfigurationFundingAccountsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminConfigurationFundingAccountsRouteRoute,
  } as any)
const AdminConfigurationFeaturesIndexRoute =
  AdminConfigurationFeaturesIndexRouteImport.update({
    id: '/features/',
    path: '/features/',
    getParentRoute: () => AdminConfigurationRouteRoute,
  } as any)
const ProviderProviderIdTeamUserIdRoute =
  ProviderProviderIdTeamUserIdRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => ProviderProviderIdTeamRouteRoute,
  } as any)
const ProviderProviderIdApplicationsApplicationIdRoute =
  ProviderProviderIdApplicationsApplicationIdRouteImport.update({
    id: '/$applicationId',
    path: '/$applicationId',
    getParentRoute: () => ProviderProviderIdApplicationsRouteRoute,
  } as any)
const PortalStartNewDepositAccountTypeRoute =
  PortalStartNewDepositAccountTypeRouteImport.update({
    id: '/$depositAccountType',
    path: '/$depositAccountType',
    getParentRoute: () => PortalStartNewRouteRoute,
  } as any)
const PortalStartGuideRetirementCheckingRoute =
  PortalStartGuideRetirementCheckingRouteImport.update({
    id: '/retirement-checking',
    path: '/retirement-checking',
    getParentRoute: () => PortalStartGuideRouteRoute,
  } as any)
const AdminConfigurationTeamUserIdRoute =
  AdminConfigurationTeamUserIdRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => AdminConfigurationTeamRouteRoute,
  } as any)
const AdminConfigurationProxyProxyIdRoute =
  AdminConfigurationProxyProxyIdRouteImport.update({
    id: '/$proxyId',
    path: '/$proxyId',
    getParentRoute: () => AdminConfigurationProxyRouteRoute,
  } as any)
const AdminConfigurationOmnibusOmnibusAccountIdRoute =
  AdminConfigurationOmnibusOmnibusAccountIdRouteImport.update({
    id: '/$omnibusAccountId',
    path: '/$omnibusAccountId',
    getParentRoute: () => AdminConfigurationOmnibusRouteRoute,
  } as any)
const PortalDepositAccountDepositAccountIdNewTransferRouteRoute =
  PortalDepositAccountDepositAccountIdNewTransferRouteRouteImport.update({
    id: '/new-transfer',
    path: '/new-transfer',
    getParentRoute: () => PortalDepositAccountDepositAccountIdRouteRoute,
  } as any)
const PortalDepositAccountDepositAccountIdHomeRouteRoute =
  PortalDepositAccountDepositAccountIdHomeRouteRouteImport.update({
    id: '/home',
    path: '/home',
    getParentRoute: () => PortalDepositAccountDepositAccountIdRouteRoute,
  } as any)
const PortalDepositAccountDepositAccountIdHomeIndexRoute =
  PortalDepositAccountDepositAccountIdHomeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PortalDepositAccountDepositAccountIdHomeRouteRoute,
  } as any)
const ProviderProviderIdApplicationsStatusApplicationIdRoute =
  ProviderProviderIdApplicationsStatusApplicationIdRouteImport.update({
    id: '/status/$applicationId',
    path: '/status/$applicationId',
    getParentRoute: () => ProviderProviderIdApplicationsRouteRoute,
  } as any)
const PortalDepositAccountDepositAccountIdNewTransferAchRoute =
  PortalDepositAccountDepositAccountIdNewTransferAchRouteImport.update({
    id: '/ach',
    path: '/ach',
    getParentRoute: () =>
      PortalDepositAccountDepositAccountIdNewTransferRouteRoute,
  } as any)
const PortalDepositAccountDepositAccountIdHomeTransactionsRoute =
  PortalDepositAccountDepositAccountIdHomeTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => PortalDepositAccountDepositAccountIdHomeRouteRoute,
  } as any)
const PortalDepositAccountDepositAccountIdHomeAchRoute =
  PortalDepositAccountDepositAccountIdHomeAchRouteImport.update({
    id: '/ach',
    path: '/ach',
    getParentRoute: () => PortalDepositAccountDepositAccountIdHomeRouteRoute,
  } as any)
const AdminProvidersProviderIdUsersUserIdRouteRoute =
  AdminProvidersProviderIdUsersUserIdRouteRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => AdminProvidersProviderIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/onboarding': typeof OnboardingRouteRoute
  '/portal': typeof PortalRouteRouteWithChildren
  '/start': typeof StartRouteRoute
  '/testing': typeof TestingRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/welcome': typeof WelcomeRoute
  '/admin/accounts': typeof AdminAccountsRouteRouteWithChildren
  '/admin/applications': typeof AdminApplicationsRouteRouteWithChildren
  '/admin/configuration': typeof AdminConfigurationRouteRouteWithChildren
  '/admin/customers': typeof AdminCustomersRouteRouteWithChildren
  '/admin/import-transactions': typeof AdminImportTransactionsRouteRouteWithChildren
  '/admin/providers': typeof AdminProvidersRouteRouteWithChildren
  '/portal/deposit-account': typeof PortalDepositAccountRouteRouteWithChildren
  '/portal/start': typeof PortalStartGuideRouteRouteWithChildren
  '/provider/$providerId': typeof ProviderProviderIdRouteRouteWithChildren
  '/admin/overview': typeof AdminOverviewRoute
  '/application-status/$applicationId': typeof ApplicationStatusApplicationIdRoute
  '/application/$applicationId': typeof ApplicationApplicationIdRoute
  '/testing/system-tools': typeof TestingSystemToolsRoute
  '/testing/users': typeof TestingUsersRoute
  '/admin/': typeof AdminIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/testing/': typeof TestingIndexRoute
  '/admin/configuration/api-keys': typeof AdminConfigurationApiKeysRouteRoute
  '/admin/configuration/funding-accounts': typeof AdminConfigurationFundingAccountsRouteRouteWithChildren
  '/admin/configuration/omnibus': typeof AdminConfigurationOmnibusRouteRouteWithChildren
  '/admin/configuration/proxy': typeof AdminConfigurationProxyRouteRouteWithChildren
  '/admin/configuration/team': typeof AdminConfigurationTeamRouteRouteWithChildren
  '/admin/providers/$providerId': typeof AdminProvidersProviderIdRouteRouteWithChildren
  '/portal/deposit-account/$depositAccountId': typeof PortalDepositAccountDepositAccountIdRouteRouteWithChildren
  '/portal/start/new': typeof PortalStartNewRouteRouteWithChildren
  '/provider/$providerId/applications': typeof ProviderProviderIdApplicationsRouteRouteWithChildren
  '/provider/$providerId/team': typeof ProviderProviderIdTeamRouteRouteWithChildren
  '/provider/$providerId/tools': typeof ProviderProviderIdToolsRouteRouteWithChildren
  '/admin/applications/$applicationId': typeof AdminApplicationsApplicationIdRoute
  '/admin/configuration/settings': typeof AdminConfigurationSettingsRoute
  '/admin/customers/$userId': typeof AdminCustomersUserIdRoute
  '/admin/providers/add': typeof AdminProvidersAddRoute
  '/provider/$providerId/start': typeof ProviderProviderIdStartRoute
  '/admin/accounts/': typeof AdminAccountsIndexRoute
  '/admin/applications/': typeof AdminApplicationsIndexRoute
  '/admin/customers/': typeof AdminCustomersIndexRoute
  '/admin/import-transactions/': typeof AdminImportTransactionsIndexRoute
  '/admin/providers/': typeof AdminProvidersIndexRoute
  '/portal/deposit-account/': typeof PortalDepositAccountIndexRoute
  '/portal/documents': typeof PortalDocumentsIndexRoute
  '/provider/$providerId/': typeof ProviderProviderIdIndexRoute
  '/portal/deposit-account/$depositAccountId/home': typeof PortalDepositAccountDepositAccountIdHomeRouteRouteWithChildren
  '/portal/deposit-account/$depositAccountId/new-transfer': typeof PortalDepositAccountDepositAccountIdNewTransferRouteRouteWithChildren
  '/admin/configuration/omnibus/$omnibusAccountId': typeof AdminConfigurationOmnibusOmnibusAccountIdRoute
  '/admin/configuration/proxy/$proxyId': typeof AdminConfigurationProxyProxyIdRoute
  '/admin/configuration/team/$userId': typeof AdminConfigurationTeamUserIdRoute
  '/portal/start/retirement-checking': typeof PortalStartGuideRetirementCheckingRoute
  '/portal/start/new/$depositAccountType': typeof PortalStartNewDepositAccountTypeRoute
  '/provider/$providerId/applications/$applicationId': typeof ProviderProviderIdApplicationsApplicationIdRoute
  '/provider/$providerId/team/$userId': typeof ProviderProviderIdTeamUserIdRoute
  '/admin/configuration/features': typeof AdminConfigurationFeaturesIndexRoute
  '/admin/configuration/funding-accounts/': typeof AdminConfigurationFundingAccountsIndexRoute
  '/admin/configuration/omnibus/': typeof AdminConfigurationOmnibusIndexRoute
  '/admin/configuration/proxy/': typeof AdminConfigurationProxyIndexRoute
  '/admin/configuration/team/': typeof AdminConfigurationTeamIndexRoute
  '/admin/providers/$providerId/': typeof AdminProvidersProviderIdIndexRoute
  '/portal/deposit-account/$depositAccountId/': typeof PortalDepositAccountDepositAccountIdIndexRoute
  '/portal/start/': typeof PortalStartGuideIndexRoute
  '/portal/start/new/': typeof PortalStartNewIndexRoute
  '/provider/$providerId/applications/': typeof ProviderProviderIdApplicationsIndexRoute
  '/provider/$providerId/team/': typeof ProviderProviderIdTeamIndexRoute
  '/provider/$providerId/tools/': typeof ProviderProviderIdToolsIndexRoute
  '/admin/providers/$providerId/users/$userId': typeof AdminProvidersProviderIdUsersUserIdRouteRoute
  '/portal/deposit-account/$depositAccountId/home/ach': typeof PortalDepositAccountDepositAccountIdHomeAchRoute
  '/portal/deposit-account/$depositAccountId/home/transactions': typeof PortalDepositAccountDepositAccountIdHomeTransactionsRoute
  '/portal/deposit-account/$depositAccountId/new-transfer/ach': typeof PortalDepositAccountDepositAccountIdNewTransferAchRoute
  '/provider/$providerId/applications/status/$applicationId': typeof ProviderProviderIdApplicationsStatusApplicationIdRoute
  '/portal/deposit-account/$depositAccountId/home/': typeof PortalDepositAccountDepositAccountIdHomeIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRouteRoute
  '/start': typeof StartRouteRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/welcome': typeof WelcomeRoute
  '/admin/configuration': typeof AdminConfigurationRouteRouteWithChildren
  '/portal/start': typeof PortalStartGuideIndexRoute
  '/admin/overview': typeof AdminOverviewRoute
  '/application-status/$applicationId': typeof ApplicationStatusApplicationIdRoute
  '/application/$applicationId': typeof ApplicationApplicationIdRoute
  '/testing/system-tools': typeof TestingSystemToolsRoute
  '/testing/users': typeof TestingUsersRoute
  '/admin': typeof AdminIndexRoute
  '/portal': typeof PortalIndexRoute
  '/testing': typeof TestingIndexRoute
  '/admin/configuration/api-keys': typeof AdminConfigurationApiKeysRouteRoute
  '/admin/applications/$applicationId': typeof AdminApplicationsApplicationIdRoute
  '/admin/configuration/settings': typeof AdminConfigurationSettingsRoute
  '/admin/customers/$userId': typeof AdminCustomersUserIdRoute
  '/admin/providers/add': typeof AdminProvidersAddRoute
  '/provider/$providerId/start': typeof ProviderProviderIdStartRoute
  '/admin/accounts': typeof AdminAccountsIndexRoute
  '/admin/applications': typeof AdminApplicationsIndexRoute
  '/admin/customers': typeof AdminCustomersIndexRoute
  '/admin/import-transactions': typeof AdminImportTransactionsIndexRoute
  '/admin/providers': typeof AdminProvidersIndexRoute
  '/portal/deposit-account': typeof PortalDepositAccountIndexRoute
  '/portal/documents': typeof PortalDocumentsIndexRoute
  '/provider/$providerId': typeof ProviderProviderIdIndexRoute
  '/portal/deposit-account/$depositAccountId/new-transfer': typeof PortalDepositAccountDepositAccountIdNewTransferRouteRouteWithChildren
  '/admin/configuration/omnibus/$omnibusAccountId': typeof AdminConfigurationOmnibusOmnibusAccountIdRoute
  '/admin/configuration/proxy/$proxyId': typeof AdminConfigurationProxyProxyIdRoute
  '/admin/configuration/team/$userId': typeof AdminConfigurationTeamUserIdRoute
  '/portal/start/retirement-checking': typeof PortalStartGuideRetirementCheckingRoute
  '/portal/start/new/$depositAccountType': typeof PortalStartNewDepositAccountTypeRoute
  '/provider/$providerId/applications/$applicationId': typeof ProviderProviderIdApplicationsApplicationIdRoute
  '/provider/$providerId/team/$userId': typeof ProviderProviderIdTeamUserIdRoute
  '/admin/configuration/features': typeof AdminConfigurationFeaturesIndexRoute
  '/admin/configuration/funding-accounts': typeof AdminConfigurationFundingAccountsIndexRoute
  '/admin/configuration/omnibus': typeof AdminConfigurationOmnibusIndexRoute
  '/admin/configuration/proxy': typeof AdminConfigurationProxyIndexRoute
  '/admin/configuration/team': typeof AdminConfigurationTeamIndexRoute
  '/admin/providers/$providerId': typeof AdminProvidersProviderIdIndexRoute
  '/portal/deposit-account/$depositAccountId': typeof PortalDepositAccountDepositAccountIdIndexRoute
  '/portal/start/new': typeof PortalStartNewIndexRoute
  '/provider/$providerId/applications': typeof ProviderProviderIdApplicationsIndexRoute
  '/provider/$providerId/team': typeof ProviderProviderIdTeamIndexRoute
  '/provider/$providerId/tools': typeof ProviderProviderIdToolsIndexRoute
  '/admin/providers/$providerId/users/$userId': typeof AdminProvidersProviderIdUsersUserIdRouteRoute
  '/portal/deposit-account/$depositAccountId/home/ach': typeof PortalDepositAccountDepositAccountIdHomeAchRoute
  '/portal/deposit-account/$depositAccountId/home/transactions': typeof PortalDepositAccountDepositAccountIdHomeTransactionsRoute
  '/portal/deposit-account/$depositAccountId/new-transfer/ach': typeof PortalDepositAccountDepositAccountIdNewTransferAchRoute
  '/provider/$providerId/applications/status/$applicationId': typeof ProviderProviderIdApplicationsStatusApplicationIdRoute
  '/portal/deposit-account/$depositAccountId/home': typeof PortalDepositAccountDepositAccountIdHomeIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/onboarding': typeof OnboardingRouteRoute
  '/portal': typeof PortalRouteRouteWithChildren
  '/start': typeof StartRouteRoute
  '/testing': typeof TestingRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/welcome': typeof WelcomeRoute
  '/admin/accounts': typeof AdminAccountsRouteRouteWithChildren
  '/admin/applications': typeof AdminApplicationsRouteRouteWithChildren
  '/admin/configuration': typeof AdminConfigurationRouteRouteWithChildren
  '/admin/customers': typeof AdminCustomersRouteRouteWithChildren
  '/admin/import-transactions': typeof AdminImportTransactionsRouteRouteWithChildren
  '/admin/providers': typeof AdminProvidersRouteRouteWithChildren
  '/portal/deposit-account': typeof PortalDepositAccountRouteRouteWithChildren
  '/portal/start': typeof PortalStartRouteRouteWithChildren
  '/provider/$providerId': typeof ProviderProviderIdRouteRouteWithChildren
  '/admin/overview': typeof AdminOverviewRoute
  '/application-status/$applicationId': typeof ApplicationStatusApplicationIdRoute
  '/application/$applicationId': typeof ApplicationApplicationIdRoute
  '/testing/system-tools': typeof TestingSystemToolsRoute
  '/testing/users': typeof TestingUsersRoute
  '/admin/': typeof AdminIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/testing/': typeof TestingIndexRoute
  '/admin/configuration/api-keys': typeof AdminConfigurationApiKeysRouteRoute
  '/admin/configuration/funding-accounts': typeof AdminConfigurationFundingAccountsRouteRouteWithChildren
  '/admin/configuration/omnibus': typeof AdminConfigurationOmnibusRouteRouteWithChildren
  '/admin/configuration/proxy': typeof AdminConfigurationProxyRouteRouteWithChildren
  '/admin/configuration/team': typeof AdminConfigurationTeamRouteRouteWithChildren
  '/admin/providers/$providerId': typeof AdminProvidersProviderIdRouteRouteWithChildren
  '/portal/deposit-account/$depositAccountId': typeof PortalDepositAccountDepositAccountIdRouteRouteWithChildren
  '/portal/start/_guide': typeof PortalStartGuideRouteRouteWithChildren
  '/portal/start/new': typeof PortalStartNewRouteRouteWithChildren
  '/provider/$providerId/applications': typeof ProviderProviderIdApplicationsRouteRouteWithChildren
  '/provider/$providerId/team': typeof ProviderProviderIdTeamRouteRouteWithChildren
  '/provider/$providerId/tools': typeof ProviderProviderIdToolsRouteRouteWithChildren
  '/admin/applications/$applicationId': typeof AdminApplicationsApplicationIdRoute
  '/admin/configuration/settings': typeof AdminConfigurationSettingsRoute
  '/admin/customers/$userId': typeof AdminCustomersUserIdRoute
  '/admin/providers/add': typeof AdminProvidersAddRoute
  '/provider/$providerId/start': typeof ProviderProviderIdStartRoute
  '/admin/accounts/': typeof AdminAccountsIndexRoute
  '/admin/applications/': typeof AdminApplicationsIndexRoute
  '/admin/customers/': typeof AdminCustomersIndexRoute
  '/admin/import-transactions/': typeof AdminImportTransactionsIndexRoute
  '/admin/providers/': typeof AdminProvidersIndexRoute
  '/portal/deposit-account/': typeof PortalDepositAccountIndexRoute
  '/portal/documents/': typeof PortalDocumentsIndexRoute
  '/provider/$providerId/': typeof ProviderProviderIdIndexRoute
  '/portal/deposit-account/$depositAccountId/home': typeof PortalDepositAccountDepositAccountIdHomeRouteRouteWithChildren
  '/portal/deposit-account/$depositAccountId/new-transfer': typeof PortalDepositAccountDepositAccountIdNewTransferRouteRouteWithChildren
  '/admin/configuration/omnibus/$omnibusAccountId': typeof AdminConfigurationOmnibusOmnibusAccountIdRoute
  '/admin/configuration/proxy/$proxyId': typeof AdminConfigurationProxyProxyIdRoute
  '/admin/configuration/team/$userId': typeof AdminConfigurationTeamUserIdRoute
  '/portal/start/_guide/retirement-checking': typeof PortalStartGuideRetirementCheckingRoute
  '/portal/start/new/$depositAccountType': typeof PortalStartNewDepositAccountTypeRoute
  '/provider/$providerId/applications/$applicationId': typeof ProviderProviderIdApplicationsApplicationIdRoute
  '/provider/$providerId/team/$userId': typeof ProviderProviderIdTeamUserIdRoute
  '/admin/configuration/features/': typeof AdminConfigurationFeaturesIndexRoute
  '/admin/configuration/funding-accounts/': typeof AdminConfigurationFundingAccountsIndexRoute
  '/admin/configuration/omnibus/': typeof AdminConfigurationOmnibusIndexRoute
  '/admin/configuration/proxy/': typeof AdminConfigurationProxyIndexRoute
  '/admin/configuration/team/': typeof AdminConfigurationTeamIndexRoute
  '/admin/providers/$providerId/': typeof AdminProvidersProviderIdIndexRoute
  '/portal/deposit-account/$depositAccountId/': typeof PortalDepositAccountDepositAccountIdIndexRoute
  '/portal/start/_guide/': typeof PortalStartGuideIndexRoute
  '/portal/start/new/': typeof PortalStartNewIndexRoute
  '/provider/$providerId/applications/': typeof ProviderProviderIdApplicationsIndexRoute
  '/provider/$providerId/team/': typeof ProviderProviderIdTeamIndexRoute
  '/provider/$providerId/tools/': typeof ProviderProviderIdToolsIndexRoute
  '/admin/providers/$providerId/users/$userId': typeof AdminProvidersProviderIdUsersUserIdRouteRoute
  '/portal/deposit-account/$depositAccountId/home/ach': typeof PortalDepositAccountDepositAccountIdHomeAchRoute
  '/portal/deposit-account/$depositAccountId/home/transactions': typeof PortalDepositAccountDepositAccountIdHomeTransactionsRoute
  '/portal/deposit-account/$depositAccountId/new-transfer/ach': typeof PortalDepositAccountDepositAccountIdNewTransferAchRoute
  '/provider/$providerId/applications/status/$applicationId': typeof ProviderProviderIdApplicationsStatusApplicationIdRoute
  '/portal/deposit-account/$depositAccountId/home/': typeof PortalDepositAccountDepositAccountIdHomeIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/onboarding'
    | '/portal'
    | '/start'
    | '/testing'
    | '/login'
    | '/logout'
    | '/welcome'
    | '/admin/accounts'
    | '/admin/applications'
    | '/admin/configuration'
    | '/admin/customers'
    | '/admin/import-transactions'
    | '/admin/providers'
    | '/portal/deposit-account'
    | '/portal/start'
    | '/provider/$providerId'
    | '/admin/overview'
    | '/application-status/$applicationId'
    | '/application/$applicationId'
    | '/testing/system-tools'
    | '/testing/users'
    | '/admin/'
    | '/portal/'
    | '/testing/'
    | '/admin/configuration/api-keys'
    | '/admin/configuration/funding-accounts'
    | '/admin/configuration/omnibus'
    | '/admin/configuration/proxy'
    | '/admin/configuration/team'
    | '/admin/providers/$providerId'
    | '/portal/deposit-account/$depositAccountId'
    | '/portal/start/new'
    | '/provider/$providerId/applications'
    | '/provider/$providerId/team'
    | '/provider/$providerId/tools'
    | '/admin/applications/$applicationId'
    | '/admin/configuration/settings'
    | '/admin/customers/$userId'
    | '/admin/providers/add'
    | '/provider/$providerId/start'
    | '/admin/accounts/'
    | '/admin/applications/'
    | '/admin/customers/'
    | '/admin/import-transactions/'
    | '/admin/providers/'
    | '/portal/deposit-account/'
    | '/portal/documents'
    | '/provider/$providerId/'
    | '/portal/deposit-account/$depositAccountId/home'
    | '/portal/deposit-account/$depositAccountId/new-transfer'
    | '/admin/configuration/omnibus/$omnibusAccountId'
    | '/admin/configuration/proxy/$proxyId'
    | '/admin/configuration/team/$userId'
    | '/portal/start/retirement-checking'
    | '/portal/start/new/$depositAccountType'
    | '/provider/$providerId/applications/$applicationId'
    | '/provider/$providerId/team/$userId'
    | '/admin/configuration/features'
    | '/admin/configuration/funding-accounts/'
    | '/admin/configuration/omnibus/'
    | '/admin/configuration/proxy/'
    | '/admin/configuration/team/'
    | '/admin/providers/$providerId/'
    | '/portal/deposit-account/$depositAccountId/'
    | '/portal/start/'
    | '/portal/start/new/'
    | '/provider/$providerId/applications/'
    | '/provider/$providerId/team/'
    | '/provider/$providerId/tools/'
    | '/admin/providers/$providerId/users/$userId'
    | '/portal/deposit-account/$depositAccountId/home/ach'
    | '/portal/deposit-account/$depositAccountId/home/transactions'
    | '/portal/deposit-account/$depositAccountId/new-transfer/ach'
    | '/provider/$providerId/applications/status/$applicationId'
    | '/portal/deposit-account/$depositAccountId/home/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/onboarding'
    | '/start'
    | '/login'
    | '/logout'
    | '/welcome'
    | '/admin/configuration'
    | '/portal/start'
    | '/admin/overview'
    | '/application-status/$applicationId'
    | '/application/$applicationId'
    | '/testing/system-tools'
    | '/testing/users'
    | '/admin'
    | '/portal'
    | '/testing'
    | '/admin/configuration/api-keys'
    | '/admin/applications/$applicationId'
    | '/admin/configuration/settings'
    | '/admin/customers/$userId'
    | '/admin/providers/add'
    | '/provider/$providerId/start'
    | '/admin/accounts'
    | '/admin/applications'
    | '/admin/customers'
    | '/admin/import-transactions'
    | '/admin/providers'
    | '/portal/deposit-account'
    | '/portal/documents'
    | '/provider/$providerId'
    | '/portal/deposit-account/$depositAccountId/new-transfer'
    | '/admin/configuration/omnibus/$omnibusAccountId'
    | '/admin/configuration/proxy/$proxyId'
    | '/admin/configuration/team/$userId'
    | '/portal/start/retirement-checking'
    | '/portal/start/new/$depositAccountType'
    | '/provider/$providerId/applications/$applicationId'
    | '/provider/$providerId/team/$userId'
    | '/admin/configuration/features'
    | '/admin/configuration/funding-accounts'
    | '/admin/configuration/omnibus'
    | '/admin/configuration/proxy'
    | '/admin/configuration/team'
    | '/admin/providers/$providerId'
    | '/portal/deposit-account/$depositAccountId'
    | '/portal/start/new'
    | '/provider/$providerId/applications'
    | '/provider/$providerId/team'
    | '/provider/$providerId/tools'
    | '/admin/providers/$providerId/users/$userId'
    | '/portal/deposit-account/$depositAccountId/home/ach'
    | '/portal/deposit-account/$depositAccountId/home/transactions'
    | '/portal/deposit-account/$depositAccountId/new-transfer/ach'
    | '/provider/$providerId/applications/status/$applicationId'
    | '/portal/deposit-account/$depositAccountId/home'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/onboarding'
    | '/portal'
    | '/start'
    | '/testing'
    | '/login'
    | '/logout'
    | '/welcome'
    | '/admin/accounts'
    | '/admin/applications'
    | '/admin/configuration'
    | '/admin/customers'
    | '/admin/import-transactions'
    | '/admin/providers'
    | '/portal/deposit-account'
    | '/portal/start'
    | '/provider/$providerId'
    | '/admin/overview'
    | '/application-status/$applicationId'
    | '/application/$applicationId'
    | '/testing/system-tools'
    | '/testing/users'
    | '/admin/'
    | '/portal/'
    | '/testing/'
    | '/admin/configuration/api-keys'
    | '/admin/configuration/funding-accounts'
    | '/admin/configuration/omnibus'
    | '/admin/configuration/proxy'
    | '/admin/configuration/team'
    | '/admin/providers/$providerId'
    | '/portal/deposit-account/$depositAccountId'
    | '/portal/start/_guide'
    | '/portal/start/new'
    | '/provider/$providerId/applications'
    | '/provider/$providerId/team'
    | '/provider/$providerId/tools'
    | '/admin/applications/$applicationId'
    | '/admin/configuration/settings'
    | '/admin/customers/$userId'
    | '/admin/providers/add'
    | '/provider/$providerId/start'
    | '/admin/accounts/'
    | '/admin/applications/'
    | '/admin/customers/'
    | '/admin/import-transactions/'
    | '/admin/providers/'
    | '/portal/deposit-account/'
    | '/portal/documents/'
    | '/provider/$providerId/'
    | '/portal/deposit-account/$depositAccountId/home'
    | '/portal/deposit-account/$depositAccountId/new-transfer'
    | '/admin/configuration/omnibus/$omnibusAccountId'
    | '/admin/configuration/proxy/$proxyId'
    | '/admin/configuration/team/$userId'
    | '/portal/start/_guide/retirement-checking'
    | '/portal/start/new/$depositAccountType'
    | '/provider/$providerId/applications/$applicationId'
    | '/provider/$providerId/team/$userId'
    | '/admin/configuration/features/'
    | '/admin/configuration/funding-accounts/'
    | '/admin/configuration/omnibus/'
    | '/admin/configuration/proxy/'
    | '/admin/configuration/team/'
    | '/admin/providers/$providerId/'
    | '/portal/deposit-account/$depositAccountId/'
    | '/portal/start/_guide/'
    | '/portal/start/new/'
    | '/provider/$providerId/applications/'
    | '/provider/$providerId/team/'
    | '/provider/$providerId/tools/'
    | '/admin/providers/$providerId/users/$userId'
    | '/portal/deposit-account/$depositAccountId/home/ach'
    | '/portal/deposit-account/$depositAccountId/home/transactions'
    | '/portal/deposit-account/$depositAccountId/new-transfer/ach'
    | '/provider/$providerId/applications/status/$applicationId'
    | '/portal/deposit-account/$depositAccountId/home/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  OnboardingRouteRoute: typeof OnboardingRouteRoute
  PortalRouteRoute: typeof PortalRouteRouteWithChildren
  StartRouteRoute: typeof StartRouteRoute
  TestingRouteRoute: typeof TestingRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  WelcomeRoute: typeof WelcomeRoute
  ProviderProviderIdRouteRoute: typeof ProviderProviderIdRouteRouteWithChildren
  ApplicationStatusApplicationIdRoute: typeof ApplicationStatusApplicationIdRoute
  ApplicationApplicationIdRoute: typeof ApplicationApplicationIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/testing': {
      id: '/testing'
      path: '/testing'
      fullPath: '/testing'
      preLoaderRoute: typeof TestingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/start': {
      id: '/start'
      path: '/start'
      fullPath: '/start'
      preLoaderRoute: typeof StartRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal': {
      id: '/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/testing/': {
      id: '/testing/'
      path: '/'
      fullPath: '/testing/'
      preLoaderRoute: typeof TestingIndexRouteImport
      parentRoute: typeof TestingRouteRoute
    }
    '/portal/': {
      id: '/portal/'
      path: '/'
      fullPath: '/portal/'
      preLoaderRoute: typeof PortalIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/testing/users': {
      id: '/testing/users'
      path: '/users'
      fullPath: '/testing/users'
      preLoaderRoute: typeof TestingUsersRouteImport
      parentRoute: typeof TestingRouteRoute
    }
    '/testing/system-tools': {
      id: '/testing/system-tools'
      path: '/system-tools'
      fullPath: '/testing/system-tools'
      preLoaderRoute: typeof TestingSystemToolsRouteImport
      parentRoute: typeof TestingRouteRoute
    }
    '/application/$applicationId': {
      id: '/application/$applicationId'
      path: '/application/$applicationId'
      fullPath: '/application/$applicationId'
      preLoaderRoute: typeof ApplicationApplicationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/application-status/$applicationId': {
      id: '/application-status/$applicationId'
      path: '/application-status/$applicationId'
      fullPath: '/application-status/$applicationId'
      preLoaderRoute: typeof ApplicationStatusApplicationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/overview': {
      id: '/admin/overview'
      path: '/overview'
      fullPath: '/admin/overview'
      preLoaderRoute: typeof AdminOverviewRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/provider/$providerId': {
      id: '/provider/$providerId'
      path: '/provider/$providerId'
      fullPath: '/provider/$providerId'
      preLoaderRoute: typeof ProviderProviderIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/start': {
      id: '/portal/start'
      path: '/start'
      fullPath: '/portal/start'
      preLoaderRoute: typeof PortalStartRouteRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/deposit-account': {
      id: '/portal/deposit-account'
      path: '/deposit-account'
      fullPath: '/portal/deposit-account'
      preLoaderRoute: typeof PortalDepositAccountRouteRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/admin/providers': {
      id: '/admin/providers'
      path: '/providers'
      fullPath: '/admin/providers'
      preLoaderRoute: typeof AdminProvidersRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/import-transactions': {
      id: '/admin/import-transactions'
      path: '/import-transactions'
      fullPath: '/admin/import-transactions'
      preLoaderRoute: typeof AdminImportTransactionsRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/customers': {
      id: '/admin/customers'
      path: '/customers'
      fullPath: '/admin/customers'
      preLoaderRoute: typeof AdminCustomersRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/configuration': {
      id: '/admin/configuration'
      path: '/configuration'
      fullPath: '/admin/configuration'
      preLoaderRoute: typeof AdminConfigurationRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/applications': {
      id: '/admin/applications'
      path: '/applications'
      fullPath: '/admin/applications'
      preLoaderRoute: typeof AdminApplicationsRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/accounts': {
      id: '/admin/accounts'
      path: '/accounts'
      fullPath: '/admin/accounts'
      preLoaderRoute: typeof AdminAccountsRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/provider/$providerId/': {
      id: '/provider/$providerId/'
      path: '/'
      fullPath: '/provider/$providerId/'
      preLoaderRoute: typeof ProviderProviderIdIndexRouteImport
      parentRoute: typeof ProviderProviderIdRouteRoute
    }
    '/portal/documents/': {
      id: '/portal/documents/'
      path: '/documents'
      fullPath: '/portal/documents'
      preLoaderRoute: typeof PortalDocumentsIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/deposit-account/': {
      id: '/portal/deposit-account/'
      path: '/'
      fullPath: '/portal/deposit-account/'
      preLoaderRoute: typeof PortalDepositAccountIndexRouteImport
      parentRoute: typeof PortalDepositAccountRouteRoute
    }
    '/admin/providers/': {
      id: '/admin/providers/'
      path: '/'
      fullPath: '/admin/providers/'
      preLoaderRoute: typeof AdminProvidersIndexRouteImport
      parentRoute: typeof AdminProvidersRouteRoute
    }
    '/admin/import-transactions/': {
      id: '/admin/import-transactions/'
      path: '/'
      fullPath: '/admin/import-transactions/'
      preLoaderRoute: typeof AdminImportTransactionsIndexRouteImport
      parentRoute: typeof AdminImportTransactionsRouteRoute
    }
    '/admin/customers/': {
      id: '/admin/customers/'
      path: '/'
      fullPath: '/admin/customers/'
      preLoaderRoute: typeof AdminCustomersIndexRouteImport
      parentRoute: typeof AdminCustomersRouteRoute
    }
    '/admin/applications/': {
      id: '/admin/applications/'
      path: '/'
      fullPath: '/admin/applications/'
      preLoaderRoute: typeof AdminApplicationsIndexRouteImport
      parentRoute: typeof AdminApplicationsRouteRoute
    }
    '/admin/accounts/': {
      id: '/admin/accounts/'
      path: '/'
      fullPath: '/admin/accounts/'
      preLoaderRoute: typeof AdminAccountsIndexRouteImport
      parentRoute: typeof AdminAccountsRouteRoute
    }
    '/provider/$providerId/start': {
      id: '/provider/$providerId/start'
      path: '/start'
      fullPath: '/provider/$providerId/start'
      preLoaderRoute: typeof ProviderProviderIdStartRouteImport
      parentRoute: typeof ProviderProviderIdRouteRoute
    }
    '/admin/providers/add': {
      id: '/admin/providers/add'
      path: '/add'
      fullPath: '/admin/providers/add'
      preLoaderRoute: typeof AdminProvidersAddRouteImport
      parentRoute: typeof AdminProvidersRouteRoute
    }
    '/admin/customers/$userId': {
      id: '/admin/customers/$userId'
      path: '/$userId'
      fullPath: '/admin/customers/$userId'
      preLoaderRoute: typeof AdminCustomersUserIdRouteImport
      parentRoute: typeof AdminCustomersRouteRoute
    }
    '/admin/configuration/settings': {
      id: '/admin/configuration/settings'
      path: '/settings'
      fullPath: '/admin/configuration/settings'
      preLoaderRoute: typeof AdminConfigurationSettingsRouteImport
      parentRoute: typeof AdminConfigurationRouteRoute
    }
    '/admin/applications/$applicationId': {
      id: '/admin/applications/$applicationId'
      path: '/$applicationId'
      fullPath: '/admin/applications/$applicationId'
      preLoaderRoute: typeof AdminApplicationsApplicationIdRouteImport
      parentRoute: typeof AdminApplicationsRouteRoute
    }
    '/provider/$providerId/tools': {
      id: '/provider/$providerId/tools'
      path: '/tools'
      fullPath: '/provider/$providerId/tools'
      preLoaderRoute: typeof ProviderProviderIdToolsRouteRouteImport
      parentRoute: typeof ProviderProviderIdRouteRoute
    }
    '/provider/$providerId/team': {
      id: '/provider/$providerId/team'
      path: '/team'
      fullPath: '/provider/$providerId/team'
      preLoaderRoute: typeof ProviderProviderIdTeamRouteRouteImport
      parentRoute: typeof ProviderProviderIdRouteRoute
    }
    '/provider/$providerId/applications': {
      id: '/provider/$providerId/applications'
      path: '/applications'
      fullPath: '/provider/$providerId/applications'
      preLoaderRoute: typeof ProviderProviderIdApplicationsRouteRouteImport
      parentRoute: typeof ProviderProviderIdRouteRoute
    }
    '/portal/start/new': {
      id: '/portal/start/new'
      path: '/new'
      fullPath: '/portal/start/new'
      preLoaderRoute: typeof PortalStartNewRouteRouteImport
      parentRoute: typeof PortalStartRouteRoute
    }
    '/portal/start/_guide': {
      id: '/portal/start/_guide'
      path: ''
      fullPath: '/portal/start'
      preLoaderRoute: typeof PortalStartGuideRouteRouteImport
      parentRoute: typeof PortalStartRouteRoute
    }
    '/portal/deposit-account/$depositAccountId': {
      id: '/portal/deposit-account/$depositAccountId'
      path: '/$depositAccountId'
      fullPath: '/portal/deposit-account/$depositAccountId'
      preLoaderRoute: typeof PortalDepositAccountDepositAccountIdRouteRouteImport
      parentRoute: typeof PortalDepositAccountRouteRoute
    }
    '/admin/providers/$providerId': {
      id: '/admin/providers/$providerId'
      path: '/$providerId'
      fullPath: '/admin/providers/$providerId'
      preLoaderRoute: typeof AdminProvidersProviderIdRouteRouteImport
      parentRoute: typeof AdminProvidersRouteRoute
    }
    '/admin/configuration/team': {
      id: '/admin/configuration/team'
      path: '/team'
      fullPath: '/admin/configuration/team'
      preLoaderRoute: typeof AdminConfigurationTeamRouteRouteImport
      parentRoute: typeof AdminConfigurationRouteRoute
    }
    '/admin/configuration/proxy': {
      id: '/admin/configuration/proxy'
      path: '/proxy'
      fullPath: '/admin/configuration/proxy'
      preLoaderRoute: typeof AdminConfigurationProxyRouteRouteImport
      parentRoute: typeof AdminConfigurationRouteRoute
    }
    '/admin/configuration/omnibus': {
      id: '/admin/configuration/omnibus'
      path: '/omnibus'
      fullPath: '/admin/configuration/omnibus'
      preLoaderRoute: typeof AdminConfigurationOmnibusRouteRouteImport
      parentRoute: typeof AdminConfigurationRouteRoute
    }
    '/admin/configuration/funding-accounts': {
      id: '/admin/configuration/funding-accounts'
      path: '/funding-accounts'
      fullPath: '/admin/configuration/funding-accounts'
      preLoaderRoute: typeof AdminConfigurationFundingAccountsRouteRouteImport
      parentRoute: typeof AdminConfigurationRouteRoute
    }
    '/admin/configuration/api-keys': {
      id: '/admin/configuration/api-keys'
      path: '/api-keys'
      fullPath: '/admin/configuration/api-keys'
      preLoaderRoute: typeof AdminConfigurationApiKeysRouteRouteImport
      parentRoute: typeof AdminConfigurationRouteRoute
    }
    '/provider/$providerId/tools/': {
      id: '/provider/$providerId/tools/'
      path: '/'
      fullPath: '/provider/$providerId/tools/'
      preLoaderRoute: typeof ProviderProviderIdToolsIndexRouteImport
      parentRoute: typeof ProviderProviderIdToolsRouteRoute
    }
    '/provider/$providerId/team/': {
      id: '/provider/$providerId/team/'
      path: '/'
      fullPath: '/provider/$providerId/team/'
      preLoaderRoute: typeof ProviderProviderIdTeamIndexRouteImport
      parentRoute: typeof ProviderProviderIdTeamRouteRoute
    }
    '/provider/$providerId/applications/': {
      id: '/provider/$providerId/applications/'
      path: '/'
      fullPath: '/provider/$providerId/applications/'
      preLoaderRoute: typeof ProviderProviderIdApplicationsIndexRouteImport
      parentRoute: typeof ProviderProviderIdApplicationsRouteRoute
    }
    '/portal/start/new/': {
      id: '/portal/start/new/'
      path: '/'
      fullPath: '/portal/start/new/'
      preLoaderRoute: typeof PortalStartNewIndexRouteImport
      parentRoute: typeof PortalStartNewRouteRoute
    }
    '/portal/start/_guide/': {
      id: '/portal/start/_guide/'
      path: '/'
      fullPath: '/portal/start/'
      preLoaderRoute: typeof PortalStartGuideIndexRouteImport
      parentRoute: typeof PortalStartGuideRouteRoute
    }
    '/portal/deposit-account/$depositAccountId/': {
      id: '/portal/deposit-account/$depositAccountId/'
      path: '/'
      fullPath: '/portal/deposit-account/$depositAccountId/'
      preLoaderRoute: typeof PortalDepositAccountDepositAccountIdIndexRouteImport
      parentRoute: typeof PortalDepositAccountDepositAccountIdRouteRoute
    }
    '/admin/providers/$providerId/': {
      id: '/admin/providers/$providerId/'
      path: '/'
      fullPath: '/admin/providers/$providerId/'
      preLoaderRoute: typeof AdminProvidersProviderIdIndexRouteImport
      parentRoute: typeof AdminProvidersProviderIdRouteRoute
    }
    '/admin/configuration/team/': {
      id: '/admin/configuration/team/'
      path: '/'
      fullPath: '/admin/configuration/team/'
      preLoaderRoute: typeof AdminConfigurationTeamIndexRouteImport
      parentRoute: typeof AdminConfigurationTeamRouteRoute
    }
    '/admin/configuration/proxy/': {
      id: '/admin/configuration/proxy/'
      path: '/'
      fullPath: '/admin/configuration/proxy/'
      preLoaderRoute: typeof AdminConfigurationProxyIndexRouteImport
      parentRoute: typeof AdminConfigurationProxyRouteRoute
    }
    '/admin/configuration/omnibus/': {
      id: '/admin/configuration/omnibus/'
      path: '/'
      fullPath: '/admin/configuration/omnibus/'
      preLoaderRoute: typeof AdminConfigurationOmnibusIndexRouteImport
      parentRoute: typeof AdminConfigurationOmnibusRouteRoute
    }
    '/admin/configuration/funding-accounts/': {
      id: '/admin/configuration/funding-accounts/'
      path: '/'
      fullPath: '/admin/configuration/funding-accounts/'
      preLoaderRoute: typeof AdminConfigurationFundingAccountsIndexRouteImport
      parentRoute: typeof AdminConfigurationFundingAccountsRouteRoute
    }
    '/admin/configuration/features/': {
      id: '/admin/configuration/features/'
      path: '/features'
      fullPath: '/admin/configuration/features'
      preLoaderRoute: typeof AdminConfigurationFeaturesIndexRouteImport
      parentRoute: typeof AdminConfigurationRouteRoute
    }
    '/provider/$providerId/team/$userId': {
      id: '/provider/$providerId/team/$userId'
      path: '/$userId'
      fullPath: '/provider/$providerId/team/$userId'
      preLoaderRoute: typeof ProviderProviderIdTeamUserIdRouteImport
      parentRoute: typeof ProviderProviderIdTeamRouteRoute
    }
    '/provider/$providerId/applications/$applicationId': {
      id: '/provider/$providerId/applications/$applicationId'
      path: '/$applicationId'
      fullPath: '/provider/$providerId/applications/$applicationId'
      preLoaderRoute: typeof ProviderProviderIdApplicationsApplicationIdRouteImport
      parentRoute: typeof ProviderProviderIdApplicationsRouteRoute
    }
    '/portal/start/new/$depositAccountType': {
      id: '/portal/start/new/$depositAccountType'
      path: '/$depositAccountType'
      fullPath: '/portal/start/new/$depositAccountType'
      preLoaderRoute: typeof PortalStartNewDepositAccountTypeRouteImport
      parentRoute: typeof PortalStartNewRouteRoute
    }
    '/portal/start/_guide/retirement-checking': {
      id: '/portal/start/_guide/retirement-checking'
      path: '/retirement-checking'
      fullPath: '/portal/start/retirement-checking'
      preLoaderRoute: typeof PortalStartGuideRetirementCheckingRouteImport
      parentRoute: typeof PortalStartGuideRouteRoute
    }
    '/admin/configuration/team/$userId': {
      id: '/admin/configuration/team/$userId'
      path: '/$userId'
      fullPath: '/admin/configuration/team/$userId'
      preLoaderRoute: typeof AdminConfigurationTeamUserIdRouteImport
      parentRoute: typeof AdminConfigurationTeamRouteRoute
    }
    '/admin/configuration/proxy/$proxyId': {
      id: '/admin/configuration/proxy/$proxyId'
      path: '/$proxyId'
      fullPath: '/admin/configuration/proxy/$proxyId'
      preLoaderRoute: typeof AdminConfigurationProxyProxyIdRouteImport
      parentRoute: typeof AdminConfigurationProxyRouteRoute
    }
    '/admin/configuration/omnibus/$omnibusAccountId': {
      id: '/admin/configuration/omnibus/$omnibusAccountId'
      path: '/$omnibusAccountId'
      fullPath: '/admin/configuration/omnibus/$omnibusAccountId'
      preLoaderRoute: typeof AdminConfigurationOmnibusOmnibusAccountIdRouteImport
      parentRoute: typeof AdminConfigurationOmnibusRouteRoute
    }
    '/portal/deposit-account/$depositAccountId/new-transfer': {
      id: '/portal/deposit-account/$depositAccountId/new-transfer'
      path: '/new-transfer'
      fullPath: '/portal/deposit-account/$depositAccountId/new-transfer'
      preLoaderRoute: typeof PortalDepositAccountDepositAccountIdNewTransferRouteRouteImport
      parentRoute: typeof PortalDepositAccountDepositAccountIdRouteRoute
    }
    '/portal/deposit-account/$depositAccountId/home': {
      id: '/portal/deposit-account/$depositAccountId/home'
      path: '/home'
      fullPath: '/portal/deposit-account/$depositAccountId/home'
      preLoaderRoute: typeof PortalDepositAccountDepositAccountIdHomeRouteRouteImport
      parentRoute: typeof PortalDepositAccountDepositAccountIdRouteRoute
    }
    '/portal/deposit-account/$depositAccountId/home/': {
      id: '/portal/deposit-account/$depositAccountId/home/'
      path: '/'
      fullPath: '/portal/deposit-account/$depositAccountId/home/'
      preLoaderRoute: typeof PortalDepositAccountDepositAccountIdHomeIndexRouteImport
      parentRoute: typeof PortalDepositAccountDepositAccountIdHomeRouteRoute
    }
    '/provider/$providerId/applications/status/$applicationId': {
      id: '/provider/$providerId/applications/status/$applicationId'
      path: '/status/$applicationId'
      fullPath: '/provider/$providerId/applications/status/$applicationId'
      preLoaderRoute: typeof ProviderProviderIdApplicationsStatusApplicationIdRouteImport
      parentRoute: typeof ProviderProviderIdApplicationsRouteRoute
    }
    '/portal/deposit-account/$depositAccountId/new-transfer/ach': {
      id: '/portal/deposit-account/$depositAccountId/new-transfer/ach'
      path: '/ach'
      fullPath: '/portal/deposit-account/$depositAccountId/new-transfer/ach'
      preLoaderRoute: typeof PortalDepositAccountDepositAccountIdNewTransferAchRouteImport
      parentRoute: typeof PortalDepositAccountDepositAccountIdNewTransferRouteRoute
    }
    '/portal/deposit-account/$depositAccountId/home/transactions': {
      id: '/portal/deposit-account/$depositAccountId/home/transactions'
      path: '/transactions'
      fullPath: '/portal/deposit-account/$depositAccountId/home/transactions'
      preLoaderRoute: typeof PortalDepositAccountDepositAccountIdHomeTransactionsRouteImport
      parentRoute: typeof PortalDepositAccountDepositAccountIdHomeRouteRoute
    }
    '/portal/deposit-account/$depositAccountId/home/ach': {
      id: '/portal/deposit-account/$depositAccountId/home/ach'
      path: '/ach'
      fullPath: '/portal/deposit-account/$depositAccountId/home/ach'
      preLoaderRoute: typeof PortalDepositAccountDepositAccountIdHomeAchRouteImport
      parentRoute: typeof PortalDepositAccountDepositAccountIdHomeRouteRoute
    }
    '/admin/providers/$providerId/users/$userId': {
      id: '/admin/providers/$providerId/users/$userId'
      path: '/users/$userId'
      fullPath: '/admin/providers/$providerId/users/$userId'
      preLoaderRoute: typeof AdminProvidersProviderIdUsersUserIdRouteRouteImport
      parentRoute: typeof AdminProvidersProviderIdRouteRoute
    }
  }
}

interface AdminAccountsRouteRouteChildren {
  AdminAccountsIndexRoute: typeof AdminAccountsIndexRoute
}

const AdminAccountsRouteRouteChildren: AdminAccountsRouteRouteChildren = {
  AdminAccountsIndexRoute: AdminAccountsIndexRoute,
}

const AdminAccountsRouteRouteWithChildren =
  AdminAccountsRouteRoute._addFileChildren(AdminAccountsRouteRouteChildren)

interface AdminApplicationsRouteRouteChildren {
  AdminApplicationsApplicationIdRoute: typeof AdminApplicationsApplicationIdRoute
  AdminApplicationsIndexRoute: typeof AdminApplicationsIndexRoute
}

const AdminApplicationsRouteRouteChildren: AdminApplicationsRouteRouteChildren =
  {
    AdminApplicationsApplicationIdRoute: AdminApplicationsApplicationIdRoute,
    AdminApplicationsIndexRoute: AdminApplicationsIndexRoute,
  }

const AdminApplicationsRouteRouteWithChildren =
  AdminApplicationsRouteRoute._addFileChildren(
    AdminApplicationsRouteRouteChildren,
  )

interface AdminConfigurationFundingAccountsRouteRouteChildren {
  AdminConfigurationFundingAccountsIndexRoute: typeof AdminConfigurationFundingAccountsIndexRoute
}

const AdminConfigurationFundingAccountsRouteRouteChildren: AdminConfigurationFundingAccountsRouteRouteChildren =
  {
    AdminConfigurationFundingAccountsIndexRoute:
      AdminConfigurationFundingAccountsIndexRoute,
  }

const AdminConfigurationFundingAccountsRouteRouteWithChildren =
  AdminConfigurationFundingAccountsRouteRoute._addFileChildren(
    AdminConfigurationFundingAccountsRouteRouteChildren,
  )

interface AdminConfigurationOmnibusRouteRouteChildren {
  AdminConfigurationOmnibusOmnibusAccountIdRoute: typeof AdminConfigurationOmnibusOmnibusAccountIdRoute
  AdminConfigurationOmnibusIndexRoute: typeof AdminConfigurationOmnibusIndexRoute
}

const AdminConfigurationOmnibusRouteRouteChildren: AdminConfigurationOmnibusRouteRouteChildren =
  {
    AdminConfigurationOmnibusOmnibusAccountIdRoute:
      AdminConfigurationOmnibusOmnibusAccountIdRoute,
    AdminConfigurationOmnibusIndexRoute: AdminConfigurationOmnibusIndexRoute,
  }

const AdminConfigurationOmnibusRouteRouteWithChildren =
  AdminConfigurationOmnibusRouteRoute._addFileChildren(
    AdminConfigurationOmnibusRouteRouteChildren,
  )

interface AdminConfigurationProxyRouteRouteChildren {
  AdminConfigurationProxyProxyIdRoute: typeof AdminConfigurationProxyProxyIdRoute
  AdminConfigurationProxyIndexRoute: typeof AdminConfigurationProxyIndexRoute
}

const AdminConfigurationProxyRouteRouteChildren: AdminConfigurationProxyRouteRouteChildren =
  {
    AdminConfigurationProxyProxyIdRoute: AdminConfigurationProxyProxyIdRoute,
    AdminConfigurationProxyIndexRoute: AdminConfigurationProxyIndexRoute,
  }

const AdminConfigurationProxyRouteRouteWithChildren =
  AdminConfigurationProxyRouteRoute._addFileChildren(
    AdminConfigurationProxyRouteRouteChildren,
  )

interface AdminConfigurationTeamRouteRouteChildren {
  AdminConfigurationTeamUserIdRoute: typeof AdminConfigurationTeamUserIdRoute
  AdminConfigurationTeamIndexRoute: typeof AdminConfigurationTeamIndexRoute
}

const AdminConfigurationTeamRouteRouteChildren: AdminConfigurationTeamRouteRouteChildren =
  {
    AdminConfigurationTeamUserIdRoute: AdminConfigurationTeamUserIdRoute,
    AdminConfigurationTeamIndexRoute: AdminConfigurationTeamIndexRoute,
  }

const AdminConfigurationTeamRouteRouteWithChildren =
  AdminConfigurationTeamRouteRoute._addFileChildren(
    AdminConfigurationTeamRouteRouteChildren,
  )

interface AdminConfigurationRouteRouteChildren {
  AdminConfigurationApiKeysRouteRoute: typeof AdminConfigurationApiKeysRouteRoute
  AdminConfigurationFundingAccountsRouteRoute: typeof AdminConfigurationFundingAccountsRouteRouteWithChildren
  AdminConfigurationOmnibusRouteRoute: typeof AdminConfigurationOmnibusRouteRouteWithChildren
  AdminConfigurationProxyRouteRoute: typeof AdminConfigurationProxyRouteRouteWithChildren
  AdminConfigurationTeamRouteRoute: typeof AdminConfigurationTeamRouteRouteWithChildren
  AdminConfigurationSettingsRoute: typeof AdminConfigurationSettingsRoute
  AdminConfigurationFeaturesIndexRoute: typeof AdminConfigurationFeaturesIndexRoute
}

const AdminConfigurationRouteRouteChildren: AdminConfigurationRouteRouteChildren =
  {
    AdminConfigurationApiKeysRouteRoute: AdminConfigurationApiKeysRouteRoute,
    AdminConfigurationFundingAccountsRouteRoute:
      AdminConfigurationFundingAccountsRouteRouteWithChildren,
    AdminConfigurationOmnibusRouteRoute:
      AdminConfigurationOmnibusRouteRouteWithChildren,
    AdminConfigurationProxyRouteRoute:
      AdminConfigurationProxyRouteRouteWithChildren,
    AdminConfigurationTeamRouteRoute:
      AdminConfigurationTeamRouteRouteWithChildren,
    AdminConfigurationSettingsRoute: AdminConfigurationSettingsRoute,
    AdminConfigurationFeaturesIndexRoute: AdminConfigurationFeaturesIndexRoute,
  }

const AdminConfigurationRouteRouteWithChildren =
  AdminConfigurationRouteRoute._addFileChildren(
    AdminConfigurationRouteRouteChildren,
  )

interface AdminCustomersRouteRouteChildren {
  AdminCustomersUserIdRoute: typeof AdminCustomersUserIdRoute
  AdminCustomersIndexRoute: typeof AdminCustomersIndexRoute
}

const AdminCustomersRouteRouteChildren: AdminCustomersRouteRouteChildren = {
  AdminCustomersUserIdRoute: AdminCustomersUserIdRoute,
  AdminCustomersIndexRoute: AdminCustomersIndexRoute,
}

const AdminCustomersRouteRouteWithChildren =
  AdminCustomersRouteRoute._addFileChildren(AdminCustomersRouteRouteChildren)

interface AdminImportTransactionsRouteRouteChildren {
  AdminImportTransactionsIndexRoute: typeof AdminImportTransactionsIndexRoute
}

const AdminImportTransactionsRouteRouteChildren: AdminImportTransactionsRouteRouteChildren =
  {
    AdminImportTransactionsIndexRoute: AdminImportTransactionsIndexRoute,
  }

const AdminImportTransactionsRouteRouteWithChildren =
  AdminImportTransactionsRouteRoute._addFileChildren(
    AdminImportTransactionsRouteRouteChildren,
  )

interface AdminProvidersProviderIdRouteRouteChildren {
  AdminProvidersProviderIdIndexRoute: typeof AdminProvidersProviderIdIndexRoute
  AdminProvidersProviderIdUsersUserIdRouteRoute: typeof AdminProvidersProviderIdUsersUserIdRouteRoute
}

const AdminProvidersProviderIdRouteRouteChildren: AdminProvidersProviderIdRouteRouteChildren =
  {
    AdminProvidersProviderIdIndexRoute: AdminProvidersProviderIdIndexRoute,
    AdminProvidersProviderIdUsersUserIdRouteRoute:
      AdminProvidersProviderIdUsersUserIdRouteRoute,
  }

const AdminProvidersProviderIdRouteRouteWithChildren =
  AdminProvidersProviderIdRouteRoute._addFileChildren(
    AdminProvidersProviderIdRouteRouteChildren,
  )

interface AdminProvidersRouteRouteChildren {
  AdminProvidersProviderIdRouteRoute: typeof AdminProvidersProviderIdRouteRouteWithChildren
  AdminProvidersAddRoute: typeof AdminProvidersAddRoute
  AdminProvidersIndexRoute: typeof AdminProvidersIndexRoute
}

const AdminProvidersRouteRouteChildren: AdminProvidersRouteRouteChildren = {
  AdminProvidersProviderIdRouteRoute:
    AdminProvidersProviderIdRouteRouteWithChildren,
  AdminProvidersAddRoute: AdminProvidersAddRoute,
  AdminProvidersIndexRoute: AdminProvidersIndexRoute,
}

const AdminProvidersRouteRouteWithChildren =
  AdminProvidersRouteRoute._addFileChildren(AdminProvidersRouteRouteChildren)

interface AdminRouteRouteChildren {
  AdminAccountsRouteRoute: typeof AdminAccountsRouteRouteWithChildren
  AdminApplicationsRouteRoute: typeof AdminApplicationsRouteRouteWithChildren
  AdminConfigurationRouteRoute: typeof AdminConfigurationRouteRouteWithChildren
  AdminCustomersRouteRoute: typeof AdminCustomersRouteRouteWithChildren
  AdminImportTransactionsRouteRoute: typeof AdminImportTransactionsRouteRouteWithChildren
  AdminProvidersRouteRoute: typeof AdminProvidersRouteRouteWithChildren
  AdminOverviewRoute: typeof AdminOverviewRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminAccountsRouteRoute: AdminAccountsRouteRouteWithChildren,
  AdminApplicationsRouteRoute: AdminApplicationsRouteRouteWithChildren,
  AdminConfigurationRouteRoute: AdminConfigurationRouteRouteWithChildren,
  AdminCustomersRouteRoute: AdminCustomersRouteRouteWithChildren,
  AdminImportTransactionsRouteRoute:
    AdminImportTransactionsRouteRouteWithChildren,
  AdminProvidersRouteRoute: AdminProvidersRouteRouteWithChildren,
  AdminOverviewRoute: AdminOverviewRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface PortalDepositAccountDepositAccountIdHomeRouteRouteChildren {
  PortalDepositAccountDepositAccountIdHomeAchRoute: typeof PortalDepositAccountDepositAccountIdHomeAchRoute
  PortalDepositAccountDepositAccountIdHomeTransactionsRoute: typeof PortalDepositAccountDepositAccountIdHomeTransactionsRoute
  PortalDepositAccountDepositAccountIdHomeIndexRoute: typeof PortalDepositAccountDepositAccountIdHomeIndexRoute
}

const PortalDepositAccountDepositAccountIdHomeRouteRouteChildren: PortalDepositAccountDepositAccountIdHomeRouteRouteChildren =
  {
    PortalDepositAccountDepositAccountIdHomeAchRoute:
      PortalDepositAccountDepositAccountIdHomeAchRoute,
    PortalDepositAccountDepositAccountIdHomeTransactionsRoute:
      PortalDepositAccountDepositAccountIdHomeTransactionsRoute,
    PortalDepositAccountDepositAccountIdHomeIndexRoute:
      PortalDepositAccountDepositAccountIdHomeIndexRoute,
  }

const PortalDepositAccountDepositAccountIdHomeRouteRouteWithChildren =
  PortalDepositAccountDepositAccountIdHomeRouteRoute._addFileChildren(
    PortalDepositAccountDepositAccountIdHomeRouteRouteChildren,
  )

interface PortalDepositAccountDepositAccountIdNewTransferRouteRouteChildren {
  PortalDepositAccountDepositAccountIdNewTransferAchRoute: typeof PortalDepositAccountDepositAccountIdNewTransferAchRoute
}

const PortalDepositAccountDepositAccountIdNewTransferRouteRouteChildren: PortalDepositAccountDepositAccountIdNewTransferRouteRouteChildren =
  {
    PortalDepositAccountDepositAccountIdNewTransferAchRoute:
      PortalDepositAccountDepositAccountIdNewTransferAchRoute,
  }

const PortalDepositAccountDepositAccountIdNewTransferRouteRouteWithChildren =
  PortalDepositAccountDepositAccountIdNewTransferRouteRoute._addFileChildren(
    PortalDepositAccountDepositAccountIdNewTransferRouteRouteChildren,
  )

interface PortalDepositAccountDepositAccountIdRouteRouteChildren {
  PortalDepositAccountDepositAccountIdHomeRouteRoute: typeof PortalDepositAccountDepositAccountIdHomeRouteRouteWithChildren
  PortalDepositAccountDepositAccountIdNewTransferRouteRoute: typeof PortalDepositAccountDepositAccountIdNewTransferRouteRouteWithChildren
  PortalDepositAccountDepositAccountIdIndexRoute: typeof PortalDepositAccountDepositAccountIdIndexRoute
}

const PortalDepositAccountDepositAccountIdRouteRouteChildren: PortalDepositAccountDepositAccountIdRouteRouteChildren =
  {
    PortalDepositAccountDepositAccountIdHomeRouteRoute:
      PortalDepositAccountDepositAccountIdHomeRouteRouteWithChildren,
    PortalDepositAccountDepositAccountIdNewTransferRouteRoute:
      PortalDepositAccountDepositAccountIdNewTransferRouteRouteWithChildren,
    PortalDepositAccountDepositAccountIdIndexRoute:
      PortalDepositAccountDepositAccountIdIndexRoute,
  }

const PortalDepositAccountDepositAccountIdRouteRouteWithChildren =
  PortalDepositAccountDepositAccountIdRouteRoute._addFileChildren(
    PortalDepositAccountDepositAccountIdRouteRouteChildren,
  )

interface PortalDepositAccountRouteRouteChildren {
  PortalDepositAccountDepositAccountIdRouteRoute: typeof PortalDepositAccountDepositAccountIdRouteRouteWithChildren
  PortalDepositAccountIndexRoute: typeof PortalDepositAccountIndexRoute
}

const PortalDepositAccountRouteRouteChildren: PortalDepositAccountRouteRouteChildren =
  {
    PortalDepositAccountDepositAccountIdRouteRoute:
      PortalDepositAccountDepositAccountIdRouteRouteWithChildren,
    PortalDepositAccountIndexRoute: PortalDepositAccountIndexRoute,
  }

const PortalDepositAccountRouteRouteWithChildren =
  PortalDepositAccountRouteRoute._addFileChildren(
    PortalDepositAccountRouteRouteChildren,
  )

interface PortalStartGuideRouteRouteChildren {
  PortalStartGuideRetirementCheckingRoute: typeof PortalStartGuideRetirementCheckingRoute
  PortalStartGuideIndexRoute: typeof PortalStartGuideIndexRoute
}

const PortalStartGuideRouteRouteChildren: PortalStartGuideRouteRouteChildren = {
  PortalStartGuideRetirementCheckingRoute:
    PortalStartGuideRetirementCheckingRoute,
  PortalStartGuideIndexRoute: PortalStartGuideIndexRoute,
}

const PortalStartGuideRouteRouteWithChildren =
  PortalStartGuideRouteRoute._addFileChildren(
    PortalStartGuideRouteRouteChildren,
  )

interface PortalStartNewRouteRouteChildren {
  PortalStartNewDepositAccountTypeRoute: typeof PortalStartNewDepositAccountTypeRoute
  PortalStartNewIndexRoute: typeof PortalStartNewIndexRoute
}

const PortalStartNewRouteRouteChildren: PortalStartNewRouteRouteChildren = {
  PortalStartNewDepositAccountTypeRoute: PortalStartNewDepositAccountTypeRoute,
  PortalStartNewIndexRoute: PortalStartNewIndexRoute,
}

const PortalStartNewRouteRouteWithChildren =
  PortalStartNewRouteRoute._addFileChildren(PortalStartNewRouteRouteChildren)

interface PortalStartRouteRouteChildren {
  PortalStartGuideRouteRoute: typeof PortalStartGuideRouteRouteWithChildren
  PortalStartNewRouteRoute: typeof PortalStartNewRouteRouteWithChildren
}

const PortalStartRouteRouteChildren: PortalStartRouteRouteChildren = {
  PortalStartGuideRouteRoute: PortalStartGuideRouteRouteWithChildren,
  PortalStartNewRouteRoute: PortalStartNewRouteRouteWithChildren,
}

const PortalStartRouteRouteWithChildren =
  PortalStartRouteRoute._addFileChildren(PortalStartRouteRouteChildren)

interface PortalRouteRouteChildren {
  PortalDepositAccountRouteRoute: typeof PortalDepositAccountRouteRouteWithChildren
  PortalStartRouteRoute: typeof PortalStartRouteRouteWithChildren
  PortalIndexRoute: typeof PortalIndexRoute
  PortalDocumentsIndexRoute: typeof PortalDocumentsIndexRoute
}

const PortalRouteRouteChildren: PortalRouteRouteChildren = {
  PortalDepositAccountRouteRoute: PortalDepositAccountRouteRouteWithChildren,
  PortalStartRouteRoute: PortalStartRouteRouteWithChildren,
  PortalIndexRoute: PortalIndexRoute,
  PortalDocumentsIndexRoute: PortalDocumentsIndexRoute,
}

const PortalRouteRouteWithChildren = PortalRouteRoute._addFileChildren(
  PortalRouteRouteChildren,
)

interface TestingRouteRouteChildren {
  TestingSystemToolsRoute: typeof TestingSystemToolsRoute
  TestingUsersRoute: typeof TestingUsersRoute
  TestingIndexRoute: typeof TestingIndexRoute
}

const TestingRouteRouteChildren: TestingRouteRouteChildren = {
  TestingSystemToolsRoute: TestingSystemToolsRoute,
  TestingUsersRoute: TestingUsersRoute,
  TestingIndexRoute: TestingIndexRoute,
}

const TestingRouteRouteWithChildren = TestingRouteRoute._addFileChildren(
  TestingRouteRouteChildren,
)

interface ProviderProviderIdApplicationsRouteRouteChildren {
  ProviderProviderIdApplicationsApplicationIdRoute: typeof ProviderProviderIdApplicationsApplicationIdRoute
  ProviderProviderIdApplicationsIndexRoute: typeof ProviderProviderIdApplicationsIndexRoute
  ProviderProviderIdApplicationsStatusApplicationIdRoute: typeof ProviderProviderIdApplicationsStatusApplicationIdRoute
}

const ProviderProviderIdApplicationsRouteRouteChildren: ProviderProviderIdApplicationsRouteRouteChildren =
  {
    ProviderProviderIdApplicationsApplicationIdRoute:
      ProviderProviderIdApplicationsApplicationIdRoute,
    ProviderProviderIdApplicationsIndexRoute:
      ProviderProviderIdApplicationsIndexRoute,
    ProviderProviderIdApplicationsStatusApplicationIdRoute:
      ProviderProviderIdApplicationsStatusApplicationIdRoute,
  }

const ProviderProviderIdApplicationsRouteRouteWithChildren =
  ProviderProviderIdApplicationsRouteRoute._addFileChildren(
    ProviderProviderIdApplicationsRouteRouteChildren,
  )

interface ProviderProviderIdTeamRouteRouteChildren {
  ProviderProviderIdTeamUserIdRoute: typeof ProviderProviderIdTeamUserIdRoute
  ProviderProviderIdTeamIndexRoute: typeof ProviderProviderIdTeamIndexRoute
}

const ProviderProviderIdTeamRouteRouteChildren: ProviderProviderIdTeamRouteRouteChildren =
  {
    ProviderProviderIdTeamUserIdRoute: ProviderProviderIdTeamUserIdRoute,
    ProviderProviderIdTeamIndexRoute: ProviderProviderIdTeamIndexRoute,
  }

const ProviderProviderIdTeamRouteRouteWithChildren =
  ProviderProviderIdTeamRouteRoute._addFileChildren(
    ProviderProviderIdTeamRouteRouteChildren,
  )

interface ProviderProviderIdToolsRouteRouteChildren {
  ProviderProviderIdToolsIndexRoute: typeof ProviderProviderIdToolsIndexRoute
}

const ProviderProviderIdToolsRouteRouteChildren: ProviderProviderIdToolsRouteRouteChildren =
  {
    ProviderProviderIdToolsIndexRoute: ProviderProviderIdToolsIndexRoute,
  }

const ProviderProviderIdToolsRouteRouteWithChildren =
  ProviderProviderIdToolsRouteRoute._addFileChildren(
    ProviderProviderIdToolsRouteRouteChildren,
  )

interface ProviderProviderIdRouteRouteChildren {
  ProviderProviderIdApplicationsRouteRoute: typeof ProviderProviderIdApplicationsRouteRouteWithChildren
  ProviderProviderIdTeamRouteRoute: typeof ProviderProviderIdTeamRouteRouteWithChildren
  ProviderProviderIdToolsRouteRoute: typeof ProviderProviderIdToolsRouteRouteWithChildren
  ProviderProviderIdStartRoute: typeof ProviderProviderIdStartRoute
  ProviderProviderIdIndexRoute: typeof ProviderProviderIdIndexRoute
}

const ProviderProviderIdRouteRouteChildren: ProviderProviderIdRouteRouteChildren =
  {
    ProviderProviderIdApplicationsRouteRoute:
      ProviderProviderIdApplicationsRouteRouteWithChildren,
    ProviderProviderIdTeamRouteRoute:
      ProviderProviderIdTeamRouteRouteWithChildren,
    ProviderProviderIdToolsRouteRoute:
      ProviderProviderIdToolsRouteRouteWithChildren,
    ProviderProviderIdStartRoute: ProviderProviderIdStartRoute,
    ProviderProviderIdIndexRoute: ProviderProviderIdIndexRoute,
  }

const ProviderProviderIdRouteRouteWithChildren =
  ProviderProviderIdRouteRoute._addFileChildren(
    ProviderProviderIdRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  OnboardingRouteRoute: OnboardingRouteRoute,
  PortalRouteRoute: PortalRouteRouteWithChildren,
  StartRouteRoute: StartRouteRoute,
  TestingRouteRoute: TestingRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  WelcomeRoute: WelcomeRoute,
  ProviderProviderIdRouteRoute: ProviderProviderIdRouteRouteWithChildren,
  ApplicationStatusApplicationIdRoute: ApplicationStatusApplicationIdRoute,
  ApplicationApplicationIdRoute: ApplicationApplicationIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
